import MobileLabPriceChart from './MobileLabPriceChart';

export default MobileLabPriceChart;
